import { SwitchWithLoading } from 'src/components/SwitchWithLoading/SwitchWithLoading';
import {
  useAssignProjectKnowledgeBaseMutation,
  useUnassignProjectKnowledgeBaseMutation,
} from 'src/services';
import { ProductsTypeBack } from 'src/constants/products';

export const UsedExistingKBAccordionItem = ({ project, item }) => {
  const [assignKB, { isLoading: assignKBisLoading }] = useAssignProjectKnowledgeBaseMutation();
  const [unassignKB, { isLoading: unassignKBIsLoading }] =
    useUnassignProjectKnowledgeBaseMutation();
  const isChecked = item.projects.some((proj) => proj.id === project.id);

  const onCheckedChange = (val) => {
    const request = {
      project_type: ProductsTypeBack[project?.project_type],
      projectId: project.id,
      body: [item.id],
    };

    val ? assignKB(request) : unassignKB(request);
  };

  return (
    <div
      className={
        'flex flex-row items-center justify-between bg-white border border-[#B8C1C633] rounded-sm-5 py-4 px-5'
      }
    >
      <p className={'text-ebony_opacity_80 font-medium text-sm'}>{item.name}</p>
      <SwitchWithLoading
        isLoading={assignKBisLoading || unassignKBIsLoading}
        defaultChecked={isChecked}
        onCheckedChange={(val: any) => onCheckedChange(val)}
      />
    </div>
  );
};
